import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Labels } from 'src/app/labels/englishLabels';
import { LoggerService } from '../../infra/logger/logger.service';
import { NotificationsService } from '../../infra/notifications/notifications.service';
import { HttpErrorInterceptor } from 'src/app/interceptors/http-error/http-error.interceptor';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorHandlerService {
  constructor(
    private readonly _loggerService: LoggerService,
    protected _notificationService: NotificationsService
  ) {}

  public handle(error: HttpErrorResponse, useErrorMessage = false): void {
    if (error.error instanceof ErrorEvent) {
      this._loggerService.warn(`Got a client side error when calling this is client side error when calling
             '${error.url} with headers ${JSON.stringify(error.headers)} - error message ${error.message}`);
    }
    if (useErrorMessage && error.error?.detail) {
      this._notificationService.error(error.error.detail);
    } else {
      switch (error.status) {
        case 422:
          this._notificationService.error(Labels.errors[422]);
          break;
        case 403:
          // Don't show generic 403 if user has access restriction (already shown by interceptor)
          if (!HttpErrorInterceptor.hasAccessRestriction) {
            this._notificationService.error(Labels.errors[403]);
          }
          break;
        case 404:
          this._notificationService.error(Labels.errors[404]);
          break;
        case 0:
          this._notificationService.error(Labels.errors.generic);
          break;
      }
    }
  }

  public isUnhandledExceptionError(statusCode: number): boolean {
    return [0, 500].includes(statusCode);
  }
}
